"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ol = require("openlayers");
var ol_map_printable_1 = require("ol-map-printable");
var templates_1 = require("./templates");
var geo_loader = require("geo-loader");
var map_width_mm;
var map_height_mm;
var map;
var loadEndTimer;
var pm;
function init() {
    var t = templates_1.templateData["raw.a3"];
    map_width_mm = t.mapSize[0];
    map_height_mm = t.mapSize[1];
    var tileLayer = new ol.layer.Tile({
        source: new ol.source.OSM()
    });
    map = new ol.Map({
        target: 'my-map',
        layers: [
            tileLayer //, dbk_layer, lineLayer, textLayer, worksLayer, signsLayer
        ],
        view: new ol.View({
            center: ol.proj.fromLonLat([23.7, 38]),
            zoom: 12
        })
    });
    pm = new ol_map_printable_1.olMapPrintable(map, "my-map-print", [map_width_mm, map_height_mm], "my-map-control", { hideGrid: false, projection: 'egsa', doNotRotateGrid: false, progressDivId: "my-map-progress" });
    geo_loader.create(pm.mapDummy, 'my-map-geo-loader', 'my-map-geo-loader-layer-list');
}
exports.init = init;
function updateGridLabelSize(grid_label_size_mm) {
    console.log('update grid');
    pm.updateGridLabelHeight(grid_label_size_mm);
    pm.mmToDist(10);
}
exports.updateGridLabelSize = updateGridLabelSize;



//////////////////
// WEBPACK FOOTER
// ./src/index.js.ts
// module id = 1
// module chunks = 0